// extracted by mini-css-extract-plugin
module.exports = {"refLink":"e_Gp","refLinkDesktop":"e_Hp","titleFont":"e_Ip"};